import { defineComponent } from 'vue';
import { CircleDollarSign, ClipboardList, Clock3, Package, TrendingUp, Users } from 'lucide-vue-next';
export default defineComponent({
    name: 'AdminDashboard',
    components: { CircleDollarSign, ClipboardList, Clock3, Package, TrendingUp, Users },
});
